import React, { Component } from 'react';
// import { Button } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

class Unavailable extends Component {

	render() {
		return (
			<div className="pilotly-notfound">
				<div>
					<h1>
						<FormattedMessage
							id="unavailable.location.message"
							defaultMessage={"Sorry, this site is not currently available in your location."}
						/>
					</h1>
				</div>
				{/* <div>
					<a href="/">
						<Button>
							<FormattedMessage
								id="unavailable.location.button.home"
								defaultMessage={"Go Home"}
							/>
						</Button>
					</a>
				</div> */}
			</div>
		);
	}
}

export default Unavailable;


// WEBPACK FOOTER //
// ./src/pages/Unavailable.js